import { observer } from 'mobx-react';
import { ReactElement } from 'react';
import { timeConfirmStore } from '../TimeConfirmModal/TimeConfirmStore';
import MatchBranchesTable from './components/MatchBranchesTable/MatchBranchesTable';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import { modalStore } from '~/mobx/modalStore';
import ModalHeader from '~/view/components/Controls/Modal/ModalHeader/ModalHeader';
import { localeStore } from '~/mobx/localesStore';
import Label from '~/view/components/Controls/Label';
import { COLORS } from '~/constants/styles';
import ModalFooter from '~/view/components/Controls/Modal/ModalFooter/ModalFooter';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import t360IntegrationStore from '~/view/screens/SettingsScreen/store/t360IntegrationStore';
import './style.scss';

const closeHandler = () => {
  modalStore.closeToYouMatchBranchesModal();
};

const saveHandler = () => {
  modalStore.closeToYouMatchBranchesModal();

  if (t360IntegrationStore.isHasChangesInTakerAndToYouBranches) {
    timeConfirmStore.openTimeConfirmModalForMatchTakerAndToYouBranches();
  }
};

const ToYouMatchBranchesModal = (): ReactElement | null => {
  if (modalStore.toYouMatchBranchesModal === null) {
    return null;
  }

  return (
    <CustomModalComponent isOpen className="to-you-match-branches-modal" onRequestClose={closeHandler} withCloseIcon>
      <ModalBackground>
        <ModalHeader title={localeStore.t('branch_matching_title')} wrapperClassName="to-you-branch-matching" titleClassName="mb-1">
          <div className="family-medium text-size-14 color-gray2">{localeStore.t('branch_matching_popup_explanation_hint')}</div>
        </ModalHeader>
        <div className="pos-relative d-flex flex-1 flex-column">
          <div className="px-8">
            <Label text={localeStore.t('branch_matching_popup_usage_explanation_hint')} color={COLORS.RED} className="to-you-warring mb-2" />
          </div>
          <MatchBranchesTable />
        </div>
        <ModalFooter>
          <Button onClick={saveHandler} title={localeStore.t('txt_save')} loading={false} size="large" />
        </ModalFooter>
      </ModalBackground>
    </CustomModalComponent>
  );
};

export default observer(ToYouMatchBranchesModal);
